import {observer} from "mobx-react";
import * as React from "react";
import {IGDPRItem} from "components/signup/shared/IGDPRItem";
import {action, computed} from "mobx";
import {handleSpacePressed} from "utils";

@observer
export class GDPRItemComponent extends React.Component<{ item: IGDPRItem, checkGDPR: boolean, onClick:()=>void }> {

  @computed
  get acceptanceRequiredAndNotGiven() {
    return this.props.checkGDPR && !this.props.item.accepted;
  }

  @action
  handleClick = () => {
    this.props.item.accepted = !this.props.item.accepted;
    this.props.onClick();
  }

  render() {
    return (
      <li className={`${this.acceptanceRequiredAndNotGiven ? 'error' : ''}`}>
        <div role={"checkbox"} className={`accept`} aria-checked={this.props.item.accepted} tabIndex={0}
             onClick={this.handleClick}
             onKeyDown={(e)=>{ handleSpacePressed(e, this.handleClick);}}
        >
          <a className="checkbox noselect">
            <i aria-hidden={true} className="material-icons">{this.props.item.accepted ? 'check_box' : 'check_box_outline_blank'}</i>
            {this.props.item.initialDescription}
          </a>
          {this.acceptanceRequiredAndNotGiven &&
            <div className="error-message">
              agreement is required to continue.
            </div>
          }
        </div>

      </li>
    );
  }
}
